import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentSectionHeader } from '@feature/types';
import { booleanStringCheck } from '@shared/ui/utils/global-utils/boolean-string-check';
import { BreadcrumbsItem } from 'jb-component-library';

import { PageHero, PageHeroImage } from './page-hero.model';
@Component({
  selector: 'jb-page-hero',
  templateUrl: './page-hero.component.html',
  styleUrls: ['./page-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeroComponent {
  breadcrumbs: BreadcrumbsItem;
  heroData: PageHero;
  heroImage?: PageHeroImage;
  sectionsData: ContentSectionHeader[];
  includeChapterSelector: boolean;
  activeIndex = 0;
}

export const pageHeroResolver = (registry, data) => {
  const heroData = data.hero?.[0] || data.hero || data;
  const hideBreadcrumbs = booleanStringCheck(
    registry['breadcrumbs'].breadcrumbs?.[0]?.hideBreadcrumbs,
  );
  return {
    breadcrumbs: hideBreadcrumbs
      ? []
      : registry.breadcrumbs?.breadcrumbs?.[0] ||
        registry.breadcrumbs?.breadcrumbs,
    heroData,
    heroImage: heroData?.image?.[0],
    sectionsData: registry.sectionHeader
      ? registry.sectionHeader.sectionHeader
      : [],
    includeChapterSelector: booleanStringCheck(
      registry.sectionHeader?.enableSelector,
    ),
  };
};
